import React from 'react'
import { Container, Footer, Header, Main } from '../component'

const Hoom = () => {
   return (
       <>
            <Container>
                <Header/>
                <Main/>
                <Footer/>
            </Container>
       </>
   )
}

export default Hoom